import React from 'react'
import Button from '@material-ui/core/Button'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import PropTypes from 'prop-types'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { isNotFoundError } from '../../../m2m-cloud-api/Api/Helper'
import { mapErrorMessage } from '../../Utilities/ApiHelper'

class DeviceSendCommandDialog extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            commandName: '',
            commandValue: '',
            loading: true,
            errorMessage: null
        }
    }

    componentDidMount() {
        const { device } = this.props
        this.props.api.deviceService.readCommandDescs( device.getId() )
            .then(commands => {
                this.setState({commands: commands, loading: false, commandName: commands && commands.length > 0 ? commands[0].name : '' })
            })
            .catch( error => {
                this.setState({loading: false, errorMessage: mapErrorMessage(error)})
            })
    }

    handleSubmit() {
        const { commandName, commandValue } = this.state
        const { t, device } = this.props
        
        this.setState({ loading: true, errorMessage: null }) 

        this.props.api.deviceService.sendSta2DeviceCommand(device.getId(), commandName, commandValue && commandValue.trim() !== "" ? commandValue.trim() : null)
        .then(result => {
            this.props.onSuccess()
        })
        .catch(error => {
            let message = mapErrorMessage(error)
            if (isNotFoundError(error)) {
                message = t('error_device_not_found', { device: error.originError.detail })
            }
            this.setState({errorMessage: message})
        })
        .finally(() => this.setState({ loading: false }))
    }

    render() {
        const { commandName, commandValue, loading, errorMessage, commands } = this.state
        const { t, classes } = this.props
        const commandNames = commands && commands.map( command => command.getName() ) || []
        
        return (
            <div>
                <Dialog open={this.props.open} onClose={this.props.onCancel} fullWidth maxWidth={'sm'} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{t('send_command')}</DialogTitle>
                    <ValidatorForm
                        ref="form"
                        onSubmit={this.handleSubmit.bind(this)}
                        onError={errors => console.log("form error:", errors)}>
                        <DialogContent>
                            <TextValidator
                                select
                                className={classes.field}
                                label={t('command_name')}
                                value={commandName}
                                onChange={(event) => {
                                    this.setState({ commandName: event.target.value })
                                }}
                                margin="dense"
                                validators={['required']}
                                errorMessages={[t('this_field_is_required')]}
                                fullWidth>
                                {commandNames.map(commandName => (
                                    <MenuItem key={commandName} value={commandName}>
                                        {commandName}
                                    </MenuItem>
                                ))}
                            </TextValidator>
                            <TextValidator
                                label={t('value')}
                                value={commandValue}
                                onChange={(event) => {
                                    this.setState({ commandValue: event.target.value })
                                }}
                                margin="dense"
                                //validators={['required']}
                                //errorMessages={[t('this_field_is_required')]}
                                fullWidth
                            />
                            {errorMessage && <DialogContentText className={classes.errorText}>
                                {errorMessage}
                            </DialogContentText>}
                        </DialogContent>
                        <DialogActions>
                            <Button disabled={loading} onClick={this.props.onCancel}>
                                {t('cancel')}
                            </Button>
                            {<Button disabled={loading} type="submit" color="primary">
                                {t('send')}
                            </Button>}
                        </DialogActions>
                    </ValidatorForm>
                </Dialog>
            </div>
        )
    }
}


DeviceSendCommandDialog.propTypes = {
    api: PropTypes.any.isRequired,
    open: PropTypes.bool,
    device: PropTypes.any.isRequired,
    org: PropTypes.any.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired

}

const styles = theme => ({
    errorText: {
        color: theme.palette.error.main,
        marginTop: 20
    },
    field: {
        marginTop: 10,
        marginBottom: 10
    }
})


export default withTranslation()(withStyles(styles)(DeviceSendCommandDialog))